import { useEffect, useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { syncAgo } from "@/lib/format";

export function RefreshNow({ onDone }) {
  const { isAdmin } = useAuth();
  const { t, lang } = useLang();
  const [last, setLast] = useState(null);
  const [busy, setBusy] = useState(false);

  const loadStatus = () =>
    api.get("/sync/status").then((r) => setLast(r.data.lastUserSync || r.data.lastGroupSync)).catch(() => {});
  useEffect(() => { loadStatus(); }, []);

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/sync/all");
      toast.success(`${t("dash.refreshed")} · ${data.users} / ${data.groups}`);
      await loadStatus();
      onDone && onDone();
    } catch (e) {
      toast.error(apiErr(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-3" data-testid="refresh-now">
      {last && (
        <span className="font-mono text-[11px] text-zinc-400" data-testid="refresh-last-sync">
          {t("dash.lastSynced")}: {syncAgo(last, lang)}
        </span>
      )}
      {isAdmin && (
        <button
          onClick={run}
          disabled={busy}
          data-testid="refresh-now-btn"
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary transition-colors hover:underline disabled:opacity-50"
        >
          <RefreshCw size={13} className={busy ? "animate-spin" : ""} /> {t("dash.refreshNow")}
        </button>
      )}
    </div>
  );
}
